import dayjs from "dayjs";
import {
  currentDateStartTime,
  currentDateEndTime,
} from "../lib/functions";

export const getPresetRange = (key) => {
  const today = dayjs();

  switch (key) {
    case "today":
      return {
        fromDate: currentDateStartTime(today),
        toDate: currentDateEndTime(today),
      };

    case "yesterday":
      return {
        fromDate: currentDateStartTime(today.subtract(1, "day")),
        toDate: currentDateEndTime(today.subtract(1, "day")),
      };

    case "last7":
      return {
        fromDate: currentDateStartTime(today.subtract(6, "day")),
        toDate: currentDateEndTime(today),
      };

    case "last30":
      return {
        fromDate: currentDateStartTime(today.subtract(29, "day")),
        toDate: currentDateEndTime(today),
      };

    case "thisMonth":
      return {
        fromDate: currentDateStartTime(today.startOf("month")),
        toDate: currentDateEndTime(today.endOf("month")),
      };

    case "lastMonth":
      return {
        fromDate: currentDateStartTime(
          today.subtract(1, "month").startOf("month")
        ),
        toDate: currentDateEndTime(
          today.subtract(1, "month").endOf("month")
        ),
      };

    default:
      return null;
  }
};
